import { render } from "./COIActionBarBlacklistTestBuyer.vue?vue&type=template&id=4b2bd552"
import script from "./COIActionBarBlacklistTestBuyer.vue?vue&type=script&lang=js"
export * from "./COIActionBarBlacklistTestBuyer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__